import type { MatchCalendarFormat, MatchWording } from '@uefadigital/panenka';
import { useMemo } from 'react';

import { useTranslateFn } from '../Translate';

const keys: (keyof MatchWording)[] = [
  '1stleg',
  'line-ups',
  'single-leg-match',
  'abandoned',
  'aggregate_abbr',
  'canceled',
  'extra_time_short',
  'full_time',
  'ft',
  'live',
  'watch_live',
  'mu_goal',
  'owngoal_abbr',
  'penalty_abbr',
  'postponed',
  'suspended',
  'unknown',
  'upcoming',
  'futsal_foulcounter',
  'tbc',
  'watch',
  'see_more',
  'view_details',
];

export const useMatchUnitTranslations = (showSeason = false) => {
  const t = useTranslateFn();

  const translations = useMemo<MatchWording>(() => Object.fromEntries(keys.map((k) => [k, t(k)])), [t]);

  const dateCalendarFormat = useMemo<MatchCalendarFormat>(
    () => ({
      sameDay: `[${t('today')}]`,
      nextDay: `[${t('tomorrow')}]`,
      nextWeek: showSeason ? 'D MMM YYYY' : 'D MMM',
      lastDay: `[${t('yesterday')}]`,
      lastWeek: showSeason ? 'D MMM YYYY' : 'D MMM',
      sameElse: showSeason ? 'D MMM YYYY' : 'D MMM',
    }),
    [showSeason, t],
  );

  return { translations, dateCalendarFormat };
};
